import React from "react";

type Props = {
  boxColor?: string; // parcel color
  tapeColor?: string; // tape stripe
  dur?: string; // slide duration (e.g. "4s")
  className?: string; // sizing via Tailwind (w-24 h-16 etc.)
};

const ShipmentAnimation: React.FC<Props> = ({
  boxColor = "#a65430",
  tapeColor = "#ffffff",
  dur = "4s",
  className = "w-24 h-16",
}) => {
  return (
    <svg
      viewBox="0 0 300 120"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Shipment in progress"
    >
      {/* baseline / conveyor */}
      <line x1="0" y1="92" x2="300" y2="92" stroke="#e5e7eb" strokeWidth="4" />

      {/* parcel */}
      <g transform="translate(-120,0)">
        <g>
          {/* box */}
          <rect x="0" y="52" width="80" height="40" rx="6" fill={boxColor} />
          {/* tape */}
          <rect
            x="36"
            y="52"
            width="8"
            height="40"
            fill={tapeColor}
            opacity="0.9"
          />
          {/* tiny notch to imply lid */}
          <rect x="36" y="52" width="8" height="8" fill="#000" opacity="0.08" />
          {/* subtle shadow */}
          <ellipse cx="40" cy="96" rx="30" ry="5" fill="#000" opacity="0.06" />
        </g>

        {/* slide left -> right */}
        <animateTransform
          attributeName="transform"
          type="translate"
          values="-120 0; 360 0"
          keyTimes="0; 1"
          dur={dur}
          repeatCount="indefinite"
          calcMode="linear"
        />

        {/* tiny bob for life */}
        <animateTransform
          attributeName="transform"
          additive="sum"
          type="translate"
          values="0 0; 0 -2; 0 0"
          keyTimes="0; .5; 1"
          dur="1.2s"
          repeatCount="indefinite"
        />
      </g>
    </svg>
  );
};

export default ShipmentAnimation;
